<template>
  <div  class="fixed inset-x-0 bottom-0 z-5 h-20 bg-white border-t border-gray-200 shadow">
    <div class="flex flex-row justify-end pt-5">
      <button @click="cancelChanges" type="button"
              class=" mr-4 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2  font-medium importantText shadow-sm hover:bg-gray-50  sm:mt-0  w-auto text-sm">        {{ $t('footer.cancel') }}
      </button>
      <button @click="saveChanges" type="button"
              class=" headerButtons  items-center mr-4 px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white  ">
        {{ $t('footer.save') }}
      </button>
    </div>
  </div>
</template>

<script setup>

import {defineEmits, ref} from "vue";

let emit = defineEmits(["hideFooter", "saveChanges"])
let closeEditMode = ref(true)

function cancelChanges()
{
  hideFooter();
}

function saveChanges()
{
  emit("saveChanges");
  hideFooter();
}

function hideFooter()
{
  closeEditMode.value = ! closeEditMode.value;
  emit("hideFooter", closeEditMode.value);
}
</script>
